import { useTranslation } from "react-i18next";
import { ChatCircleText, LifebuoyIcon } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Kbd,
} from "@hulahoop/ui";

const HELP_CENTER_URL = "https://hulahoop.media/ayuda";
const SUPPORT_EMAIL = "soporte@hulahoop.media";

const SHORTCUTS: [string, string][] = [
  ["⌘K", "shell.shortcut_search"],
  ["⌘↵", "shell.shortcut_detail"],
  ["↑ ↓", "shell.shortcut_records"],
  ["Esc", "shell.shortcut_escape"],
];

export function ShellHelpDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent width="sm">
        <DialogHeader>
          <DialogTitle>{t("shell.help")}</DialogTitle>
          <DialogDescription>{t("shell.help_description")}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col divide-y divide-border text-sm">
          <a
            href={HELP_CENTER_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2.5 py-2.5 hover:text-foreground focus-ring rounded-md"
          >
            <LifebuoyIcon className="shrink-0 text-muted-foreground" aria-hidden />
            <span className="flex-1">{t("shell.help_center")}</span>
          </a>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="flex items-center gap-2.5 py-2.5 hover:text-foreground focus-ring rounded-md"
          >
            <ChatCircleText className="shrink-0 text-muted-foreground" aria-hidden />
            <span className="flex-1">{t("shell.write_us")}</span>
            <span className="text-xs text-muted-foreground">{SUPPORT_EMAIL}</span>
          </a>
          <div className="flex flex-col gap-1.5 pt-2.5">
            <p className="text-xs font-medium text-muted-foreground">{t("shell.shortcuts")}</p>
            {SHORTCUTS.map(([key, description]) => (
              <div key={key} className="flex items-center gap-2.5">
                <Kbd className="shrink-0">{key}</Kbd>
                <span className="text-muted-foreground">{t(description)}</span>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
